(function ($) {
  $(document).ready(function ($) {
    var isMobile = window.matchMedia("only screen and (max-width: 949px)").matches;
    // Instagram Carousel
    if ($(".instagram-custom-carousel").length) {
      var $igCarousel = $(".instagram-custom-carousel .owl-carousel");
      $igCarousel.owlCarousel({
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 1000,
        smartSpeed: 1000,
        autoplayHoverPause: false,
        loop: true,
        margin: 50,
        nav: false,
        dots: false,
        items: 4,
        slideBy: 2,
        responsive: {
          0: {
            stagePadding: 45,
            margin: 0,
            items: 1,
            slideBy: 1,
          },
          768: {
            stagePadding: 100,
            margin: 50,
            items: 2,
            slideBy: 1,
          },
          1280: {
            stagePadding: 100,
          },
          1366: {
            stagePadding: 150,
          },
          1920: {
            stagePadding: 150,
          },
          2000: {
            stagePadding: 250,
          },
        },
      });

      $igCarousel.on("drag.owl.carousel", function (event) {
        $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
        // $(this).trigger("play.owl.autoplay"); // user performs any actions

        // AutoplayHoverPause will re-enable if set to true
      });

      // $igCarousel.on("mousewheel", ".owl-stage", function (e) {
      //   if (e.deltaX > 0) {
      //     $igCarousel.trigger("next.owl");
      //   } else {
      //     $igCarousel.trigger("prev.owl");
      //   }
      //   e.preventDefault();
      // });
    }
  });
})(jQuery);
